import { ChevronDownIcon, ChevronRightIcon } from "lucide-react";
import { useState } from "react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar"

export function NavMain({
  items,
  setActiveTab
}) {
  const [openItems, setOpenItems] = useState(new Set(['Resources & Insights Hub']));

  const handleItemClick = (item) => {
    const navigationMap = {
      'Dashboard': 'dashboard',
      'User Management': 'users',
      'User Approvals': 'approvals'
    };
    
    const tabKey = navigationMap[item.title];
    if (tabKey && setActiveTab) {
      setActiveTab(tabKey);
    }
  };

  const handleSubItemClick = (subItem) => {
    const navigationMap = {
      'Blog Management': 'blogs',
      'Resources Hub': 'resources',
      'Learning Paths': 'learning-paths',
      'Webinar Library': 'webinars',
      'Leadership & Advisory': 'leadership',
      'About Us Content': 'about-content'
    };
    
    const tabKey = navigationMap[subItem.title];
    if (tabKey && setActiveTab) {
      setActiveTab(tabKey);
    }
  };

  const toggleOpen = (itemTitle) => {
    setOpenItems(prev => {
      const next = new Set(prev);
      if (next.has(itemTitle)) {
        next.delete(itemTitle);
      } else {
        next.add(itemTitle);
      }
      return next;
    });
  };

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => {
            const hasSubItems = item.items && item.items.length > 0;
            const isOpen = openItems.has(item.title);

            if (hasSubItems) {
              return (
                <Collapsible
                  key={item.title}
                  open={isOpen}
                  onOpenChange={() => toggleOpen(item.title)}
                >
                  <SidebarMenuItem>
                    <CollapsibleTrigger asChild>
                      <SidebarMenuButton 
                        tooltip={item.title}
                        className="w-full"
                      >
                        {item.icon && <item.icon />}
                        <span>{item.title}</span>
                        {isOpen ? (
                          <ChevronDownIcon className="ml-auto h-4 w-4" />
                        ) : (
                          <ChevronRightIcon className="ml-auto h-4 w-4" />
                        )}
                      </SidebarMenuButton>
                    </CollapsibleTrigger>
                    <CollapsibleContent>
                      <SidebarMenuSub>
                        {item.items?.map((subItem) => (
                          <SidebarMenuSubItem key={subItem.title}>
                            <SidebarMenuSubButton 
                              asChild
                              onClick={() => handleSubItemClick(subItem)}
                            >
                              <a href="#" onClick={(e) => e.preventDefault()}>
                                {subItem.icon && <subItem.icon />}
                                <span>{subItem.title}</span>
                              </a>
                            </SidebarMenuSubButton>
                          </SidebarMenuSubItem>
                        ))}
                      </SidebarMenuSub>
                    </CollapsibleContent>
                  </SidebarMenuItem>
                </Collapsible>
              );
            }

            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton 
                  tooltip={item.title}
                  onClick={() => handleItemClick(item)}
                  asChild
                >
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {item.icon && <item.icon />}
                    <span>{item.title}</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
